import api from "@/api"
import store from "@/store"
import Vue from "vue"

class Dict{
  dict = {}
  constructor(dict){
    if(dict){
      this.dict = dict
    }
  }

  async init(names){
    const ps=[]
    names.forEach(name => {
      if(store.state.dicts && store.state.dicts[name]){
        Vue.set(this.dict,name,store.state.dicts[name])
      }else{
        Vue.set(this.dict,name,[])
        ps.push(
          api.channelApi.getChannel({ parentId: 166 }).then(res=>{
            let list = res.data
            let arr = []
            list.map(item=>{
              arr.push({ name: item.name, id: item.id });
            })
            arr.unshift({ name: "全部", id: "" });
            this.dict[name]= arr
            store.commit("SET_DICTS",{
              label:name,
              value:arr
            })
          })
        )
      }

    });
    try{
      await Promise.all(ps)
    }catch(err){
      console.log("字典请求错误",err)
    }
  }
}

const install =  function(Vue){
  Vue.mixin({
    data(){
      if(this.$options.dicts instanceof Array && this.$options.dicts.length>0){
        return { ditc:{}}
      }else{
        return {}
      }
    },
    created(){
      if(this.$options.dicts instanceof Array && this.$options.dicts.length>0){
        new Dict(this.dict).init(this.$options.dicts)
      }
    }
  })
}

export default {install}